import { COOKIE_MORTGAGE_SEARCH } from '@/constants/cookies';
import { PRODUCT_MORTGAGES } from '@/constants/products';
import { getMortgageSearch } from '@/graphql/queries/banking/mortgage';
import { getProviders } from '@/graphql/queries/shared/institution';
import lang from '@/lang/middleware/products/mortgage';

export default async ({ $apolloQuery, app, $cookies, redirect, store }) => {
  const backHome = () => redirect(302, app.localePath('/compare-mortgages/'));
  const code = $cookies.get(COOKIE_MORTGAGE_SEARCH);
  if (!code) return backHome();

  store.$i18n.mergeLocaleMessage('en', lang.en);
  const title = store.$i18n.t('results.title');
  store.commit('pageContent/setHead', { title });
  await $apolloQuery(getProviders, { product: PRODUCT_MORTGAGES }).then(providers => store.commit('providers/setList', providers));
  await $apolloQuery(getMortgageSearch, { code, page: 1 }).then(search => {
    store.commit('utils/setPagination', search.results.meta.pagination);
    store.commit('search/set', search);
  }).catch(e => {
    backHome();
  });
};
